<template>
    <div class="pb-10">
      <v-sheet outlined class="ma-2 pa-2 mb-2 d-flex align-center">
        <v-btn depressed @click="$emit('prev')" color="white"><v-icon> mdi-arrow-left </v-icon></v-btn>
        &nbsp;&nbsp;세부 내역 ({{ code }})
      </v-sheet>

      <!-- 트래블러 정보 섹션 -->
      <v-sheet outlined class="ma-2 pa-4 mb-2">
        <v-row v-if="!travelerInfoLoading && travelerInfo">
          <v-col cols="12" md="6">
            <div class="mb-2">
              <span class="font-weight-bold">코드:</span> {{ travelerInfo.code }}
            </div>
            <div class="mb-2">
              <span class="font-weight-bold">이름:</span> {{ travelerInfo.name || '-' }}
            </div>
            <div class="mb-2">
              <span class="font-weight-bold">이메일:</span> {{ travelerInfo.email || '-' }}
            </div>
            <div class="mb-2">
              <span class="font-weight-bold">인센티브:</span> {{ travelerInfo.incentive_percent || '-' }}%
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="mb-2">
              <span class="font-weight-bold">전화번호:</span> {{ travelerInfo.phone || '-' }}
            </div>
            <div class="mb-2">
              <span class="font-weight-bold">은행:</span> {{ travelerInfo.bank || '-' }}
            </div>
            <div class="mb-2">
              <span class="font-weight-bold">계좌번호:</span> {{ travelerInfo.account_number || '-' }}
            </div>
          </v-col>
        </v-row>
        <v-row v-else-if="travelerInfoLoading">
          <v-col cols="12">
            <div class="text-center">트래블러 정보를 불러오는 중...</div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12">
            <div class="text-center text--secondary">트래블러 정보를 찾을 수 없습니다.</div>
          </v-col>
        </v-row>
      </v-sheet>
  
      <!-- 본문 -->
      <v-sheet outlined class="pa-2 ma-2">
        <v-sheet v-if="isLoading">
          <span>Loading... Please wait</span>
        </v-sheet>
        <v-sheet v-else>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>{{ month + 1 }} 월</th>
                  <th>예약 결제</th>
                  <th>예약 취소</th>
                  <th>매출 합계</th>
                </tr>
              </thead>
              <tbody>
                <tr class="accentBg">
                  <td class="text-center">계</td>
                  <td>{{ $toComma(total.payed_amount) }}</td>
                  <td>{{ $toComma(total.cancel_amount) }}</td>
                  <td>
                    {{ $toComma(total.total_amount) }}
                    &nbsp;&nbsp;
                    <strong>인센티브 금액: {{ $toComma(calculateIncentive()) }}</strong>
                  </td>
                </tr>
                <tr v-for="(item, index) in items" :key="index">
                  <td :class="{ 'red--text': dayjs(item.date).day() === 0 || dayjs(item.date).day() === 6 }">{{ dayjs(item.date).format("D") }}일</td>
                  <td>{{ $toComma(item.payed_amount) }}</td>
                  <td>{{ $toComma(item.cancel_amount) }}</td>
                  <td>{{ $toComma(item.total_amount) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-sheet>
    </div>
  </template>
  <script>
  import statusService from "@/api/stats-service"
  export default {
    props: {
      code: {
        type: String,
        required: true,
      },
      month: {
        type: Number,
        required: true,
      },
      total: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      isLoading: false,
      items: [],
      travelerInfo: null,
      travelerInfoLoading: false,
    }),
    mounted() {
      this.load()
      this.loadTravelerInfo()
    },
    methods: {
      calculateIncentive() {
        if (!this.total || !this.travelerInfo || !this.travelerInfo.incentive_percent) {
          return 0
        }
        return Math.round(this.total.total_amount * this.travelerInfo.incentive_percent / 100)
      },
      async loadTravelerInfo() {
        if (!this.code) {
          return
        }
        try {
          this.travelerInfoLoading = true
          const response = await this.$http.get(`/api/promotion/select/travelers/${this.code}`)
          this.travelerInfo = response.data
          console.log('Traveler info:', this.travelerInfo)
        } catch (e) {
          console.log('Error loading traveler info:', e)
          this.travelerInfo = null
        } finally {
          this.travelerInfoLoading = false
        }
      },
      async load() {
        if (!this.code) {
          return
        }
        try {
          this.isLoading = true
          let fromDayjs = this.dayjs().month(this.month).startOf("month")
          let toDayjs = fromDayjs.endOf("month")
  
          const from = fromDayjs.format("YYYY-MM-DD")
          const to = toDayjs.format("YYYY-MM-DD")
  
          let result = await statusService.getTravelerSalesStats(false, from, to, this.code)
          result.sort((a, b) => a.date - b.date)
          this.items = result
        } catch (e) {
          console.log(e)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
  </script>
  <style></style>
  